.root {
  display: flex;
  flex-direction: column;
  scroll-margin-top: 8rem;
  height: 100%;
}

.mediaWrapper {
  position: relative;
  background-color: rgb(var(--color-render));
  padding-bottom: 125%;
  height: 0;
  border-radius: 10px;
}
.media {
  border-radius: 10px;
  
}
@media (min-width: 768px){
  .mediaWrapper {
    z-index: 1;
  } 
}

.mediaWrapper > a {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.header {
  display: block;
  margin-bottom: 0.25rem;
}

.wrap {
  white-space: normal;
  font-size: 0.875rem;
}

.info {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-top: 0.5rem;
}

.header:hover {
  text-decoration: underline;
  text-underline-offset: 0.125rem;
}

.title {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  color: rgb(var(--color-gray-900));
}

.subtitle {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: rgb(var(--color-gray-600));
}

.banner {
  display: block;
  text-align: center;
  position: absolute;
  left: 1rem;
  right: 1rem;
  bottom: 1rem;
  padding: 0.5rem;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 1rem;
  line-height: 1;
  pointer-events: none;
}

.badge {
  /* position: absolute; */
  /* left: 0.75rem; */
  /* bottom: 0.75rem; */
  padding: 0.125rem 0.25rem;
  font-weight: 700;
  text-transform: capitalize!important;
  font-size: 11px!important;
  line-height: 1;
  background: rgb(var(--color-white))!important;
  color: rgb(var(--color-gray-900));
}

/* .isSupplement {
  top: 0.75rem;
  bottom: auto;
} */

.badge_bottom {
  bottom: 0.75rem;
  left: 0.75rem;
  top: auto;
}

@media (min-width: 640px) {
  .info {
    padding-left: 0;
    padding-right: 0;
  }

  .badge {
    /* font-size: 0.875rem; */
  }
}

.badgePreorder {
  background-color: #000000;
  color: #ffffff;
}

.skeleton {
  background: rgb(var(--color-render));
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.text {
  display: block;
  margin-top: 0;
  margin-bottom: 0;
  height: auto;
  transform-origin: 0 60%;
  transform: scale(1, 0.6);
}

.text:empty:before {
  content: "\00a0";
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}

.soldOut {
  position: absolute;
  left: 1rem;
  right: 1rem;
  bottom: 1rem;
  background-color: rgb(var(--color-white));
  color: rgb(var(--color-gray-900));
  border-radius: 0.125rem;
  font-size: 1rem;
  line-height: 1;
  padding: 1rem;
  text-align: center;
  font-weight: 700;
  text-transform: uppercase;
  pointer-events: none;
  border: 1px solid transparent;
}

.message {
  font-size: 0.625rem;
  font-weight: 700;
  line-height: 1;
  display: inline-block;
  text-transform: uppercase;
  color: var(--color);
}

.quickMessage {
  font-size: 0.75rem;
  line-height: 1;
  display: inline-block;
  font-weight: 700;
  padding: 0.25rem;
  text-transform: uppercase;
  margin-top: 0.5rem;
  background-color: var(--color);
  color: var(--contrastColor);
}

.message:empty,
.quickMessage:empty {
  display: none;
}

.quickBadge:empty {
  display: none;
}

.quickBadge {
  display: inline-block;
  text-transform: uppercase;
  font-size: 0.75rem;
  background-color: rgb(var(--color-gray-100));
  padding: 0.25rem;
  line-height: 1;
  font-weight: 700;
}

.hoverQuickButton {
  padding: 0.5rem 0;
}

.wishButton {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}

.hitButton {
  position: relative;
  font-weight: var(--font-heading-weight);
  font-feature-settings: var(--font-heading-settings);
  font-family: var(--font-heading-family);
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: 'ss09' on, 'ss05' on, 'ss08' on, 'ss03' on, 'ss01' on;
  text-transform: uppercase;
  white-space: nowrap;
  /* padding: 1rem 2rem; */
  padding: 1rem 0.5rem;
  border-width: 1px;
  border-radius: 4px;
  font-size: 0.875rem;
  line-height: 0.875rem;
  cursor: pointer;
}
.hitButton .single {
  
}

.hitButton:hover {
  background-color: rgb(var(--color-gray-900), 0.05);
}

.hitButton:active {
  background-color: rgb(var(--color-gray-900), 0.1);
}

.hitButton.loading {
  color: transparent !important;
}

.hitButton.loading::after {
  content: "";
  display: block;
  width: 1rem;
  height: 1rem;
  border-radius: 100%;
  box-sizing: content-box;
  position: absolute;
  border: 0.25rem solid rgba(var(--color-gray-900), 0.2);
  border-left: 0.25rem solid rgba(var(--color-gray-900), 1);
  animation: loading 750ms infinite linear;
  top: calc(50% - 0.75rem);
  left: calc(50% - 0.75rem);
}
.hitButton.loading:hover::after {
  border: 0.25rem solid rgba(var(--color-white), 0.2);
  border-left: 0.25rem solid rgba(var(--color-white), 1);
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 767px) {
  .lowStockLabel {
    position: absolute;
    text-transform: uppercase;
    left: -0.25rem;
    top: 0px;
    transform: translateY(-50%);
    line-height: 1;
    font-size: 0.625rem;
    background-color: rgb(var(--color-gray-700));
    color: white;
    padding: 0.125rem 0.25rem;
    border-radius: 2px;
  }

  .quickBuy {
    padding: 0.5rem;
  }
}

@media (min-width: 768px) {
  .drawerContainer {
    display: none;
  }

  .hitButton {
    position: relative;
  }

  .lowStockLabel {
    position: absolute;
    top: 0px;
    transform: translateY(-50%);
    left: -0.25rem;
    background-color: rgb(var(--color-gray-700));
    color: rgb(var(--color-white));
    padding: 0 0.125rem;
    display: inline-flex;
    align-items: center;
    clip-path: circle(7px at 7px 50%);
    border-radius: 7px;
    max-width: 100%;
    white-space: break-spaces;
    z-index: 1;
  }

  .lowStockLabel span {
    font-size: 0.625rem;
    line-height: 1;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    max-width: 85px;
  }

  .hitButton:hover .lowStockLabel {
    clip-path: circle(100% at 50% 50%);
    transition-duration: 300ms;
    transition-timing-function: ease;
    transition-delay: 0s;
    transition-property: clip-path;
    z-index: 2;
  }
  .info{
    position: relative;
  }
  .cartActions .hitButton {
    min-width: 50px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cartActions .hitButton:only-child {
    width: 100%;
  }
}

.dialogHeader {
  padding: 0 1rem;
}

.dialogTitle {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.dialogTitle .h4 {
  flex: 1;
}

.dialogItemHeader {
  display: block;
  margin-bottom: 0.5rem;
}

.dialogItem {
  display: flex;
}

.dialogItemImage {
  width: 6rem;
  margin-right: 1rem;
}

.dialogItemImage img {
  background-color: rgb(var(--color-render));
}

.dialogCloseButton {
  position: absolute;
  right: 1rem;
  bottom: calc(100% + 1rem);
}

@media (min-width: 768px) {
  .dialogCloseButton {
    visibility: hidden;
  }
}

.dialogCloseButton {
  opacity: 0;
  transition: opacity 150ms ease;
}

.cartModal.open .dialogCloseButton,
.wishModal.open .dialogCloseButton {
  transition: opacity 150ms ease 150ms;
  opacity: 1;
}

.dialogItemTitle {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  color: rgb(var(--color-gray-900));
}

.dialogItemSubtitle {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: rgb(var(--color-gray-700));
}

.wishModal {
  display: initial;
}

.dialogItemBadge {
  display: initial;
}

.dialogItemMessage {
  display: initial;
} 

.cartContainer {
  display: initial;
}

.cartActions {
  display: initial;
}

@media (max-width: 767px) {
  .cartModal::before,
  .wishModal::before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0 0 0 / 60%);
    visibility: hidden;
    opacity: 0;
    transition: visibility 150ms ease, opacity 150ms ease;
    z-index: 99999999;
  }

  .cartDialog,
  .wishDialog {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 4rem);
    visibility: hidden;
    transform: translateY(100%);
    transition: visibility 300ms ease, transform 300ms ease;
    background: rgb(var(--color-white));
    color: rgb(var(--color-gray-900));
    padding-top: 1rem;
    padding-bottom: 1rem;
    /* padding-bottom: 3rem; */
    z-index: 99999999;
    border-radius: 16px 16px 0 0;
  }

  .cartModal.open::before,
  .wishModal.open::before {
    visibility: visible;
    opacity: 1;
    transition: visibility 300ms ease, opacity 300ms ease;
  }

  .cartModal.open .cartDialog,
  .wishModal.open .wishDialog {
    transform: translateY(0);
    visibility: visible;
  }

  .dialogListItem {
    border-width: 1px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 1rem;
    line-height: 1rem;
    padding: 1rem 0;
    text-transform: uppercase;
    font-weight: 700;
    font-family: inherit;
    text-decoration: none;
    appearance: none;
    white-space: nowrap;
    -webkit-appearance: none;
  }

  .dialogList {
    display: grid;
    gap: 1rem;
    grid-gap: 0.5rem;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 2rem;
    padding: 0 1rem;
  }

  .cartActions {
    position: relative;
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(2, 1fr);
    padding: 1rem;
  }

  .cartButton {
    position: absolute;
    right: 0.5rem;
    bottom: 0.5rem;
  }
}

@media (min-width: 768px) {
  .wishDialog {
    position: absolute;
    top: 3rem;
    right: 0.5rem;
    background-color: rgb(var(--color-white));
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.15);
    visibility: hidden;
  }

  .wishDialog::before {
    content: "";
    position: absolute;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid white;
    right: calc(1rem - 6px);
    bottom: 100%;
  }

  .wishModal.open .wishDialog {
    visibility: visible;
  }

  .dialogHeader {
    display: none;
  }

  .dialogList {
    display: flex;
    flex-direction: column;
  }

  .dialogListItem {
    padding: 0.5rem 1rem;
    font-weight: 700;
    text-align: center;
  }
  .groupProductDialogListItem {
    font-size: 11px;
  }

  .dialogListItem:hover,
  .dialogListItem:focus {
    background-color: rgb(var(--color-gray-100));
  }

  .dialogListItem:active {
    background-color: rgb(var(--color-gray-200));
  }

  .cartButton {
    position: absolute;
    left: 1rem;
    right: 1rem;
    bottom: 1rem;
    background-color: rgb(var(--color-white));
  }

  .cartButton {
    visibility: hidden;
  }

  .mediaWrapper:hover .cartButton {
    visibility: visible;
  }

  .wishContainer:hover + .cartContainer .cartButton {
    visibility: hidden;
  }

  .cartActions {
    display: grid;
    padding: 0.5rem;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
  }

  .nonSizeVariant {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  .nonSizeButtonVariant {
    width: 100%;
  }

  .cartDialog {
    position: absolute;
    left: 1rem;
    right: 1rem;
    bottom: 1rem;
    background-color: rgb(var(--color-white));
    clip-path: inset(100% 0px 0px 0px);
    visibility: hidden;
    transition: clip-path 150ms ease, visibility 150ms;
    border-width: 1px;
  }

  .cartModal.open .cartDialog {
    clip-path: inset(0px 0px 0px 0px);
    visibility: visible;
    z-index: 2;
  }

  .cartModal.open .cartButton {
    opacity: 0;
  }
}

/* Quick-Add modification */
.quickAddWrapper {
  color: #000000;
}
/* .quickAddWrapper {
  display: none;
}
@media (min-width: 768px){
  .root:hover .quickAddWrapper {
    display: block;
    position: absolute;
    width: auto;
    padding: 20px 12px 0 12px;
    margin: 0 -13px;
    border-left: 1px solid rgba(var(--color-gray-900), 0.2);
    border-right: 1px solid rgba(var(--color-gray-900), 0.2);
    background-color: #fff;
    z-index: 1;
    top: 100%;
    left: 0;
    right: 0;
  }
  .quickAddWrapper .cartActions {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    position: absolute;
    background-color: #fff;
    padding-bottom: 12px;
    top: 100%;
    left: -1px;
    right: -1px;
    border-left: 1px solid rgba(var(--color-gray-900), 0.2);
    border-right: 1px solid rgba(var(--color-gray-900), 0.2);
    border-bottom: 1px solid rgba(var(--color-gray-900), 0.2);
    border-radius: 0 0 4px 4px;
  }
} */

/* .quickAddWrapper .title {
  margin-top: 40px;
  font-weight: bold;
} */


/*
.productCardRoot:not(.productCardTest){
    .quickAddWrapper{
        display: none;
    }
}
.productCardRoot.productCardTest{
    .quickAddWrapper {
      display: none;
    }

    @media (min-width: 768px){
     .quickAddOld {
        display: none !important;
     }
      &:hover {
        padding: 12px;
        margin: -13px;
        background-color: #ffffff;
        border: 1px solid rgba(var(--color-gray-900), 0.2);
        border-radius: 4px;
      }
      &:hover .quickAddWrapper {
        display: block;
        position: absolute;
        width: auto;
        padding: 20px 12px 0 12px;
        margin: 0 -13px;
        border-left: 1px solid rgba(var(--color-gray-900), 0.2);
        border-right: 1px solid rgba(var(--color-gray-900), 0.2);
        background-color: #fff;
        z-index: 1;
        top: 100%;
        left: 0;
        right: 0;
      }
      .quickAddWrapper .cartActions {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        position: absolute;
        background-color: #fff;
        padding-bottom: 12px;
        top: 100%;
        left: -1px;
        right: -1px;
        border-left: 1px solid rgba(var(--color-gray-900), 0.2);
        border-right: 1px solid rgba(var(--color-gray-900), 0.2);
        border-bottom: 1px solid rgba(var(--color-gray-900), 0.2);
        border-radius: 0 0 4px 4px;
      }
    }
}
*/
.hitButton[disabled]{
  /* opacity: 0.5; */
  background-color: #dcdcdc;
  /* pointer-events: none; */
  background-color: rgba(220, 220, 220, 0.55);
  border-color: rgba(var(--color-border),0.5);
  color: rgba(var(--color-black),0.5);
}
.hitButton > .notify {
  top: 0;
  left: 0;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  border-radius: 0;
  border: 0;
  z-index: 1;
}


/* AB Testing Styles */
.info {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.cartContainer {
  display: block;
}
.cartButton {
  visibility: visible;
  position: relative;
  bottom: 0;
  padding: 12px;
  width: 100%;
  left: 0;
  right: 0;
  background-color: rgb(var(--color-gray-900)) !important;
  color: rgb(var(--color-white));
}
.cartButton:disabled {
  pointer-events: none;
  background-color: rgb(var(--color-gray-300)) !important;
  /* color: rgb(var(--color-black)); */
}
.cartModal {
  display: block;
  z-index: 10;
}
.cartDialog {
  left: 0;
  right: 0;
  bottom: 0;
}
.newSoldOut {
    display: none;
}
.newSoldOut {
    display: block;
    position: relative;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
@media (max-width: 767px) {
  .cartButton {
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 900;
  }
}
.cartButton.loading {
  background-color: rgb(var(--color-gray-500));
}
.cartButton:after {
  border: 0.25rem solid rgba(var(--color-white), 0.2) !important;
  border-left: 0.25rem solid rgba(var(--color-white), 1) !important;
}
@media (min-width: 768px) {
  .card-info {
      z-index: 2;
  }
  .card-mediaWrapper {
      z-index: 1;
  }
  .card-mediaWrapper:hover {
    z-index: 3;
  }
}
.badge {
  font-size: 11px;
}
.card-info {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.cartContainer {
  margin-top: auto;
}
.cartDialog {
  bottom: 0;
  left: 0;
  right: 0;
}
.notify {
  font-size: 10px;
  font-weight: 900;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  width: 100%;
  margin-top: 8px;
  padding: 12px;
  white-space: nowrap;
  text-decoration: none;
  border-radius: 100px;
  border: 1px solid rgb(var(--color-black));
}

@media (min-width: 768px){
  .notify {
    height: 40px;
  }
}
.notify svg {
  margin-right: 4px;
}
@media (min-width: 768px){
  .notify {
    font-size: 16px;
  }
}
.isGroupProduct {
  padding: 0.7rem 0.5rem;
}
@media (max-width: 767px){
  .isGroupProduct {
    font-size: 0.5rem;
  } 
}
@media(min-width: 768px){
  .isGroupProduct {
    font-size: 9px;
    width: calc(50% - 0.5rem);
  }
}


/* Picker */

.variantHitbntWrapper {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
}

.decreaseBundleBtn {
  width: calc(50% - 16px);
  left: 0;
  z-index: 9;
  height: 100%;
  position: absolute;
  font-size:1rem;
}
.decreaseBundleBtn:hover + .hitButton {
  background-color: rgb(var(--color-gray-900), 0.05);
} 

.decreaseBundleBtn:active + .hitButton {
  background-color: rgb(var(--color-gray-900), 0.1);
} 

.increaseBundleBtn {
  width: calc(50% - 16px);
  right: 0;
  height: 100%;
  position: absolute;
  font-size:1rem;
  pointer-events: none;
}

.variantHitbntWrapper .hitButton {
  width: 100%;
}

.qty_count {
  padding:8px;
}

.bubble {
  color: #fff;
  pointer-events: none;
  background: #3f3f46;
  border-radius: 100px;
  min-width: 24px;
  padding: 5px 2px;
  font-size: 9px;
  position: absolute;
  top: -7px;
  right: -4px;
}

/* Single Variant Bundle Button */

.variantButtonWrapper {
  margin-top: 8px;
  position: relative;
}

.singleVariantButtonDecrease {
  position: absolute;
  bottom: 0;
  left: 0;
  color: rgb(var(--color-white));
  font-size: 1.5rem;
  font-weight: var(--font-heading-weight);
  z-index: 999;
  width: 50%;
  height: 100%;
}

.singleVariantButtonIncrease {
  position: absolute;
  bottom: 0;
  right: 0;
  color: rgb(var(--color-white));
  font-size: 1.5rem;
  font-weight: var(--font-heading-weight);
  z-index: 999;
  width: 50%;
  height: 100%;
}

.optionsSelected {
  visibility: visible;
}

.noOptionsSelected {
  visibility: hidden;
  pointer-events: none;
}
.breastCancerBadge {
  max-width: 20px;
  height: auto;
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  pointer-events: none;
}

/* Multiple Badges */

.grocer_badges {
  display: flex;
  position: absolute;
  flex-direction: column;
  top:0.5rem;
  left:0.5rem;
  gap:0.5rem;
}

.grocer_badges .badge {
  position: relative;
  bottom:unset;
  left:unset;
  width: fit-content;
  border-radius:100px;
}

/* New Badge Styles */

.product_badge_wrapper {
  position: absolute;
  pointer-events: none;
    height: 100%;
    top: 0;
    width: 100%;
}

.product_badges {
  left: 0.75rem;
  bottom:0.75rem;
  width:150px;
  position: absolute;
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
}

.badge {
  width:fit-content;
}

@media(max-width:768px){
  .product_badges {
    bottom:1.5rem;
  }
}

.badge.badge_bottom {
  bottom:0;
  left:0;
  position: absolute;
}

.isSupplement .product_badges {
  top:0.75rem;
}

.productSoldOut .product_badges {
  top:0.75rem;
  bottom:unset;
}